<div class="modal-header">
  <h3 class="modal-title">{{ titelModal }}</h3>
  <button type="button" class="close text-primary" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="notesForm" (ngSubmit)="add()">
    <div class="form-group">
      <input type="hidden" formControlName="id"  value={{notes.id}}>
      <input type="hidden" formControlName="userid"  value={{notes.userid}}>


      <quill-editor placeholder="Ingrese Nota" [modules]="quillConfig" formControlName="note" [style]="{ 'height': '20rem','width': '29rem', 'background-color': '#f9f9f9' }"  (onSelectionChanged)="onSelectionChanged($event)"></quill-editor>

      @if (loading && f.note.errors && f.note.touched) {
        <small class="form-text text-muted danger" class="invalid-feedback">
          @for (validation of notes_validation_messages.note; track validation) {
            <div>
              @if (notesForm.get('note').hasError(validation.type) ) {
                <div class="error-message">
                  {{validation.message}}
                </div>
              }
            </div>
          }
        </small>
      }
    </div>
    @if (successMessage) {
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <ngb-alert class="mt-3" type="success" (close)="successMessage = ''">{{ successMessage }}</ngb-alert>
          </div>
        </div>
      </div>
    }
    @if (errorMessage) {
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <ngb-alert  class="mt-3" type="danger" (close)="errorMessage = ''">{{ errorMessage }}</ngb-alert>
          </div>
        </div>
      </div>
    }
    <div class="form-group">
      <div class="row">
        <div class="col-md-12 text-right">
          <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold" style="width: 120px;"
            (click)="activeModal.close('Close click')">
            Cerrar
          </button>
          <button type="submit"
            class="btn btn-outline-primary  rounded-pill text-dark  font-weight-bold mr-2"
            style="width: 120px;"
            [disabled]="!submitted  && notesForm.invalid"
            >
            @if (submitted && notesForm.valid) {
              <div>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Cargando...
              </div>
            }
            @if (!submitted) {
              <span>
                Guardar
              </span>
            }
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
